import { render, staticRenderFns } from "./Navbarlist.vue?vue&type=template&id=085902ed&"
import script from "./Navbarlist.vue?vue&type=script&lang=js&"
export * from "./Navbarlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports